/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ConvertLCCommand } from '../models/ConvertLCCommand';
import type { CreateLCCommand } from '../models/CreateLCCommand';
import type { DeleteLCByIdCommand } from '../models/DeleteLCByIdCommand';
import type { EditLCCommand } from '../models/EditLCCommand';
import type { LCDocumentDto } from '../models/LCDocumentDto';
import type { LCDto } from '../models/LCDto';
import type { LCDtoPaginatedResult } from '../models/LCDtoPaginatedResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LetterOfCreditsService {
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiLetterOfCredits(
        requestBody?: CreateLCCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LetterOfCredits',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param pageNumber
     * @param pageSize
     * @param filterByBusinessUnit
     * @param filterByVendor
     * @param filterByStatus
     * @param filterByType
     * @param filterByBank
     * @param filterByEstablishmentDateStart
     * @param filterByEstablishmentDateEnd
     * @param searchByReferenceNumber
     * @param sortBy
     * @param sortOrder
     * @returns LCDtoPaginatedResult OK
     * @throws ApiError
     */
    public static getApiLetterOfCredits(
        pageNumber?: number,
        pageSize?: number,
        filterByBusinessUnit?: Array<string>,
        filterByVendor?: Array<string>,
        filterByStatus?: Array<string>,
        filterByType?: Array<string>,
        filterByBank?: Array<string>,
        filterByEstablishmentDateStart?: string,
        filterByEstablishmentDateEnd?: string,
        searchByReferenceNumber?: string,
        sortBy?: string,
        sortOrder?: string,
    ): CancelablePromise<LCDtoPaginatedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LetterOfCredits',
            query: {
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'FilterByBusinessUnit': filterByBusinessUnit,
                'FilterByVendor': filterByVendor,
                'FilterByStatus': filterByStatus,
                'FilterByType': filterByType,
                'FilterByBank': filterByBank,
                'FilterByEstablishmentDateStart': filterByEstablishmentDateStart,
                'FilterByEstablishmentDateEnd': filterByEstablishmentDateEnd,
                'SearchByReferenceNumber': searchByReferenceNumber,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiLetterOfCredits(
        id: string,
        requestBody?: DeleteLCByIdCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/LetterOfCredits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns LCDto OK
     * @throws ApiError
     */
    public static getApiLetterOfCredits1(
        id: string,
    ): CancelablePromise<LCDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LetterOfCredits/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns string OK
     * @throws ApiError
     */
    public static patchApiLetterOfCredits(
        id: string,
        requestBody?: EditLCCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/LetterOfCredits/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param selectedLCs
     * @param unselectedLCs
     * @param filterByBusinessUnit
     * @param filterByVendor
     * @param filterByStatus
     * @param filterByType
     * @param filterByBank
     * @param filterByEstablishmentDateStart
     * @param filterByEstablishmentDateEnd
     * @param searchByReferenceNumber
     * @param sortBy
     * @param sortOrder
     * @param timeZone
     * @returns binary OK
     * @throws ApiError
     */
    public static getApiLetterOfCreditsExport(
        selectedLCs?: Array<string>,
        unselectedLCs?: Array<string>,
        filterByBusinessUnit?: Array<string>,
        filterByVendor?: Array<string>,
        filterByStatus?: Array<string>,
        filterByType?: Array<string>,
        filterByBank?: Array<string>,
        filterByEstablishmentDateStart?: string,
        filterByEstablishmentDateEnd?: string,
        searchByReferenceNumber?: string,
        sortBy?: string,
        sortOrder?: string,
        timeZone?: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LetterOfCredits/export',
            query: {
                'SelectedLCs': selectedLCs,
                'UnselectedLCs': unselectedLCs,
                'FilterByBusinessUnit': filterByBusinessUnit,
                'FilterByVendor': filterByVendor,
                'FilterByStatus': filterByStatus,
                'FilterByType': filterByType,
                'FilterByBank': filterByBank,
                'FilterByEstablishmentDateStart': filterByEstablishmentDateStart,
                'FilterByEstablishmentDateEnd': filterByEstablishmentDateEnd,
                'SearchByReferenceNumber': searchByReferenceNumber,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
                'TimeZone': timeZone,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public static postApiLetterOfCreditsConvert(
        requestBody?: ConvertLCCommand,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LetterOfCredits/convert',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @param formData
     * @returns string OK
     * @throws ApiError
     */
    public static putApiLetterOfCreditsDocuments(
        id: string,
        formData?: {
            Files?: Array<Blob>;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/LetterOfCredits/{id}/documents',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns LCDocumentDto OK
     * @throws ApiError
     */
    public static getApiLetterOfCreditsDocuments(
        id: string,
    ): CancelablePromise<Array<LCDocumentDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LetterOfCredits/{id}/documents',
            path: {
                'id': id,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns string OK
     * @throws ApiError
     */
    public static deleteApiLetterOfCreditsDocuments(
        id: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/LetterOfCredits/documents/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
